import { Divider, Drawer, Grid, Typography } from '@material-ui/core';
import { RegistroResponse, RegistroStatus } from 'common/genericTypes';
import { Button, SmSpace, TextField } from 'm2m.components';
import React, { useState } from 'react';
import { CredenciadosResponse } from 'store/modules/credenciados/credenciadosReponse';

export enum ValidationCredenciadoRequestKind {
  CREDENCIADO = 'CREDENCIADO',
}

interface ValidationCredenciadoDrawerProps {
  credenciado?: CredenciadosResponse;
  opened: boolean;
  onClose: () => void;
  reject?: boolean;
  onSubmit: (id: string, status: RegistroStatus, justification: string) => void;
  kind: ValidationCredenciadoRequestKind;
  disableButtons?: boolean;
}

export const ValidationCredenciadoDrawer: React.FC<ValidationCredenciadoDrawerProps> = (props) => {
  const [justification, setJustification] = useState<string>();

  const handleSubmitClick = (status: RegistroStatus) => () => {
    props.onSubmit(props?.credenciado?.credenciadoEmissorGuid ?? '', status, justification ?? '');
    setJustification(undefined);
  };

  return (
    <Drawer
      anchor="right"
      open={props.opened}
      onClose={props.onClose}
      PaperProps={{ style: { padding: '40px', width: 520 } }}
    >
      <Grid container>
        <Grid item sm={12}>
          <Typography variant="h3">{`${props.reject ? 'Rejeitar' : 'Aprovar'} Credenciamento`}</Typography>
          <SmSpace />
          <Divider variant="fullWidth" />
          <SmSpace />
          {!props.reject && (
            <>
              <Typography variant="body2" display={'inline'}>
                {`Tem certeza que deseja aprovar?  `}
              </Typography>
              <SmSpace />
              <Typography variant="body2">{`Credenciado: ${props.credenciado?.credenciadoRazaoSocial}`}</Typography>
              <Typography variant="body2">{`Emissor: ${props.credenciado?.emissorRazaoSocial}`}</Typography>
              <SmSpace />
            </>
          )}
          <TextField
            label="Justificativa"
            value={justification}
            rows={5}
            onChange={setJustification}
            multiline
            fullWidth
          />
          <SmSpace />
          <Button
            variant="contained"
            fullWidth
            color={props.reject ? 'error' : 'primary'}
            onClick={handleSubmitClick(props.reject ? RegistroStatus.Reprovado : RegistroStatus.Aprovado)}
            disabled={props.disableButtons ?? false}
          >
            {props.reject ? 'Rejeitar' : 'Aprovar'}
          </Button>
          <SmSpace />
          <Button variant="outlined" fullWidth onClick={props.onClose} disabled={props.disableButtons ?? false}>
            {'Cancelar'}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
};
